import Api from '@/script/api';

class SaveProductQueue {
    constructor(options = {}) {
        this.queue = [];
        this.processing = false;
        this.maxRetry = options.maxRetry || 3;
        this.delay = options.delay || 100; // 每个任务之间的间隔（ms）
        this.requestTimeoutMs = options.requestTimeoutMs || 30000; // 单次请求超时（ms）
        this.retryBaseDelayMs = options.retryBaseDelayMs || 800; // 重试基础退避（ms）
        this.retryMaxDelayMs = options.retryMaxDelayMs || 15000; // 最大退避（ms）
    }

    add(item, action = 'save', commit) {
        // console.log("@@@@@@@@@@@@@@@@@@往里面加商品",item)
        // 同一个商品的保存/删除在高频编辑时会疯狂堆积：这里做“最后一次为准”的去重，避免线上高峰期队列越积越慢
        const id = item?.id;
        if (id !== undefined && id !== null) {
            this.queue = this.queue.filter(t => t?.item?.id !== id);
        }
        this.queue.push({ item, retryCount: 0, action });
        this._processNext(commit); // 每次添加都尝试启动处理流程
    }

    async _processNext(commit) {
        if (this.processing) return;
        if (this.queue.length === 0) return;

        this.processing = true;
        // console.log("@@@@@@@@@@@@@@@@@@死循环处理商品")
        try {
            while (this.queue.length > 0) {
                const task = this.queue[0];
                try {
                    if (task.action === 'delete') {
                        await this._deleteProduct(task.item);
                    } else if (task.action === 'save') {
                        await this._saveProduct(task.item, commit);
                    }
                    this.queue.shift(); // 处理成功，移出队列
                } catch (err) {
                    task.retryCount += 1;
                    console.warn('远程保存失败:', err);

                    if (task.retryCount > this.maxRetry) {
                        console.error('任务重试失败，已放弃：', task.item);
                        this.queue.shift(); // 超出重试，丢弃任务
                    } else {
                        const backoff = this._getRetryDelayMs(task.retryCount);
                        console.log(`第 ${task.retryCount} 次重试，等待 ${backoff}ms`);
                        await this._sleep(backoff);
                    }
                }

                await this._sleep(this.delay);
            }
        } finally {
            this.processing = false;
        }
    }

    _sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    _getRetryDelayMs(retryCount) {
        // 指数退避 + 抖动：避免高峰期所有用户同时重试把服务打爆
        const exp = Math.min(this.retryMaxDelayMs, this.retryBaseDelayMs * Math.pow(2, Math.max(0, retryCount - 1)));
        const jitter = exp * (0.3 * Math.random()); // 0~30%
        return Math.floor(exp + jitter);
    }

    async _postGzipWithTimeout(url, data) {
        // 线上高峰期慢时，axios 默认 10 分钟超时会让队列“看起来卡死”；这里用 AbortController 做硬超时
        const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
        const timer = setTimeout(() => {
            try {
                controller?.abort();
            } catch (e) { }
        }, this.requestTimeoutMs);

        try {
            return await Api.postGzip(url, data, undefined, {
                timeout: this.requestTimeoutMs,
                signal: controller?.signal,
            });
        } finally {
            clearTimeout(timer);
        }
    }

    async _saveProduct(data, commit) {
        /////////////////////////////////////////////////重点在这里修改见图失败的
        let res = await this._postGzipWithTimeout("/admintooltaobaoaccount/goodsdetailsedit", data)
        if (res.code == 1) {
            if (commit) {
                commit("UPDATE_PRODUCT_SAVE_STATUS_BY_ID", {
                    id: data.id,
                    value: 2,
                });
            }
            return true;
        }
        const errMsg = res.err || res.msg || "保存失败";
        commit("UPDATE_PRODUCT_SAVE_STATUS_BY_ID", {
            id: data.id,
            value: 3,
            msg: errMsg,
        });
        if (errMsg.includes("已锁定")) {
            return true;
        }
        throw new Error(errMsg)
    }
    async _deleteProduct(data) {
        let res = await this._postGzipWithTimeout("/admintooltaobaoaccount/goodspublishremovetag", {
            dou_goods_publish_ids: [data.id],
            remove_tag: 1
        })
        if (res.code == 1) {
            return true;
        }
        throw new Error(res.err || res.msg)
    }
}

export default new SaveProductQueue();
